import DefaultLayout from "src/components/common/layouts/DefaultLayout"
import { useCreatorSearch } from "src/components/hooks/useCreatorSearch"
import SelectCharacters, {
  CharacterParams,
} from "src/components/pages/creator/search/SelectCharacters"
import Search from "src/components/pages/creator/top/Search"
import HTMLHead from "src/components/utils/HTMLHead"
import { useCallback } from "react"
import _ from "lodash"
import queryString from "query-string"
import { useRouter } from "next/router"
import { useLocalStorage } from "react-use"

const STORAGE_KEY = "creatorSearch_characterSearchParams"

const characterInitial: CharacterParams = {
  role: "",
  sex: "",
  hair_style: "",
  hair_arrange: "",
  hair_color: "",
  eye_color: "",
  age: "",
  height: "",
  weight: "",
}

export type CharacterParamKeys = keyof CharacterParams

const CharacterSearchPage: React.FC = () => {
  const { setSearchType, searchType, updateSearchText, urlParams } =
    useCreatorSearch()

  const [selected, setSelected] = useLocalStorage<CharacterParams>(
    STORAGE_KEY,
    characterInitial,
  )

  const router = useRouter()

  const onSubmit = useCallback(
    (e: React.FormEvent) => {
      e.preventDefault()
      const arr: string[] = []
      _.each(selected, (value, key) => {
        if (value) {
          arr.push(`${key}:${value}`)
        }
      })
      const tmp: { q?: string; c: string } = { q: urlParams.q, c: arr.join() }
      if (tmp.q === "" && tmp.c === "") return
      // clean
      Object.keys(tmp).forEach((key) => {
        if (key !== "q" && key !== "c") return
        if (!tmp[key]) {
          delete tmp[key]
        }
      })
      const query = queryString.stringify(tmp)
      const url = `/creator/${searchType}?${query}`
      router.push(url)
    },
    [router, searchType, selected, urlParams.q],
  )

  const onClear = useCallback(() => {
    setSelected(characterInitial)
    updateSearchText("")
  }, [setSelected, updateSearchText])

  return (
    <DefaultLayout isCreatorMyPage>
      <HTMLHead path="creator/search/characters" />
      <main>
        <form onSubmit={onSubmit}>
          <Search
            searchType={searchType}
            setSearchType={setSearchType}
            updateSearchText={updateSearchText}
            isRequired={false}
            showCharacter={false}
            searchText={urlParams.q || ""}
            disableCharacter
          />

          <div className="l-single -medium">
            <header className="p-searchDetail-header">
              <h1 className="p-searchDetail-title">キャラを選択</h1>
            </header>

            <SelectCharacters selected={selected} setSelected={setSelected} />

            <div className="p-searchDetail-action">
              <div className="p-searchDetail-clear">
                <button
                  type="button"
                  className="p-searchDetail-clear-button c-button-secondary -outline -full"
                  onClick={onClear}
                >
                  クリア
                </button>
              </div>
              <div className="p-searchDetail-submit">
                <button
                  type="submit"
                  className="p-searchDetail-submit-button c-button-secondary -full"
                >
                  検索する
                </button>
              </div>
            </div>
          </div>
        </form>
      </main>
    </DefaultLayout>
  )
}

export default CharacterSearchPage
